import { QUERY_KEYS, UpdateUserRequest } from '@24i/nxg-sdk-photon/src';
import { useUserData } from '@24i/nxg-sdk-smartott-shared/src/context/UserData';
import { useMutation, useQueryClient } from 'react-query';

export const useUpdateUserMutation = () => {
    const client = useUserData();
    const queryClient = useQueryClient();

    const { mutate, mutateAsync } = useMutation(
        QUERY_KEYS.user,
        (body: UpdateUserRequest) => client.updateUser(body),
        {
            onSuccess: () => queryClient.invalidateQueries(QUERY_KEYS.user),
        }
    );

    return {
        mutate,
        mutateAsync,
    };
};
